
<div :class="jel_getClassObject(content)">
  <Menu :content="contentMenu" @click.native="estOuvert = !estOuvert">
    <template #element="{ itemElement }">
      <div
        v-show="estOuvert"
        class="d-md-flex mx-2 overflow-hidden"
        :class="[itemElement.image ? 'p-0' : 'justify-content-between']"
      >
        <b-img-lazy
          v-if="itemElement.image"
          class="img-item"
          :src="jel_getFichierSrc(itemElement.image)"
          :alt="itemElement.item"
        />
        <div class="d-flex align-items-center">
          <p class="texte-element overflow-hidden pb-0">{{ itemElement.item }}</p>
        </div>
      </div>
    </template>
  </Menu>
</div>
